<template>
  <span class="custom-icon-wrapper">
    <div
      v-html="cleanedSvg(svgContent)"
      class="centered-content custom-icon icon3"
      @click.prevent="handleClick"
    ></div>

    <el-tooltip
      v-if="formattedName.length > 15"
      :content="formattedName"
      placement="top"
    >
      <div class="centered-content truncated-name">
        {{ truncatedName }}
      </div>
    </el-tooltip>

    <div v-else class="centered-content">
      {{ formattedName }}
    </div>
  </span>
</template>

<script>
import { fetchSvgContentFromS3 ,addIconsToLocal} from "@/repo/iconsRepo";
export default {
  name: "IconsV2",
  props: {
    icon: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      svgContent: "",
    };
  },
  methods: {
    handleClick() {
      this.$emit("icon-click", this.icon.key);
    },
    cleanedSvg(rawSvg) {
      return rawSvg
        ?.replace(/\\n/g, "")
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, "");
    },
  },
  computed: {
    formattedName() {
      const name = this.icon.name || "";
      return /-(fill|outline|filled|fill-1)$/i.test(name)
        ? name.replace(/-(fill|outline|filled|fill-1)$/i, "")
        : name;
    },
    truncatedName() {
      return this.formattedName.slice(0, 15) + "...";
    },
  },
  async mounted() {
    if (this.icon.key) {
      try {
        const [fetchedIcon] = await fetchSvgContentFromS3([this.icon.key]);
        if (fetchedIcon && fetchedIcon.content) {
          this.svgContent = fetchedIcon.content;
           await addIconsToLocal([{
          ...this.icon,
          content: fetchedIcon.content
        }]);
        } else {
          console.warn("No SVG content found for:", this.icon.key);
        }
      } catch (err) {
        console.error("Failed to fetch SVG for:", this.icon.key, err);
      }
    }
  },
};
</script>

<style scoped>
.custom-icon-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.centered-content {
  display: flex;
  margin-top: 5px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
